const HunterJob = () =>
  import(
    /* webpackChunkName: "hunter" */ "@/app/admin/hunterorder/positon/positon"
  );

const HunterJobDetail = () =>
  import(
    /* webpackChunkName: "hunter" */ "@/app/admin/hunterorder/positon/detail"
  );
const HunterOrder = () =>
  import(
    /* webpackChunkName: "hunter" */ "@/app/admin/hunterorder/order/order"
  );
const PersonMatch = () =>
  import(
    /* webpackChunkName: "hunter" */ "@/app/admin/hunterorder/personMatch/PersonMatch"
  );
const RecommendSign = () =>
  import(
    /* webpackChunkName: "hunter" */ "@/app/admin/hunterorder/personMatch/RecommendSign"
  );
export default [
  {
    path: "hunter-job",
    name: "hunterjob",
    component: HunterJob,
    meta: { title: "职位管理", key: "hunter-job", permission: "job_manager" }
  },
  {
    path: "hunter-job-detail/:id",
    name: "hunterjobDetail",
    component: HunterJobDetail,
    meta: { title: "职位详情", key: "hunter-job", permission: "job_manager" }
  },
  {
    path: "hunter-order",
    name: "hunterorder",
    component: HunterOrder,
    meta: { title: "做单管理", key: "hunter-order" }
  },
  {
    path: "person-match",
    name: "PersonMatch",
    component: PersonMatch,
    meta: { title: "人岗匹配", key: "person-match" }
  },
  {
    path: "recommend-sign",
    name: "RecommendSign",
    component: RecommendSign,
    meta: { title: "标记人岗匹配", key: "recommend-sign" }
  }
];
